"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = exports.asyncMergeSort = exports.getTimezoneSeparatorFromString = exports.normalizeMillisecondsField = exports.normalizeMillisecondsFieldInString = exports.jsDate = exports.anyTrue = exports.allTrue = exports.typeIsArray = exports.isNull = exports.numerical_sort = exports.removeNulls = void 0;
function removeNulls(things) {
    return things.filter(function (x) { return x != null; });
}
exports.removeNulls = removeNulls;
function numerical_sort(things, direction) {
    return things.sort(function (a, b) {
        if (direction == null || direction === 'asc' || direction === 'ascending') {
            return a - b;
        }
        else {
            return b - a;
        }
    });
}
exports.numerical_sort = numerical_sort;
function isNull(value) {
    return value === null;
}
exports.isNull = isNull;
exports.typeIsArray = Array.isArray || (function (value) { return ({}.toString.call(value) === '[object Array]'); });
function allTrue(things) {
    if ((0, exports.typeIsArray)(things)) {
        return things.every(function (x) { return x; });
    }
    else {
        return things;
    }
}
exports.allTrue = allTrue;
function anyTrue(things) {
    if ((0, exports.typeIsArray)(things)) {
        return things.some(function (x) { return x; });
    }
    else {
        return things;
    }
}
exports.anyTrue = anyTrue;
//The export below is to make it easier if js Date is overwritten with CQL Date
exports.jsDate = Date;
function normalizeMillisecondsFieldInString(string, msString) {
    // TODO: verify we are only removing numeral digits
    var timezoneField;
    msString = normalizeMillisecondsField(msString);
    var _a = string.split('.'), beforeMs = _a[0], msAndAfter = _a[1];
    var timezoneSeparator = getTimezoneSeparatorFromString(msAndAfter);
    if (timezoneSeparator) {
        timezoneField = msAndAfter != null ? msAndAfter.split(timezoneSeparator)[1] : undefined;
    }
    if (timezoneField == null) {
        timezoneField = '';
    }
    return (string = beforeMs + '.' + msString + timezoneSeparator + timezoneField);
}
exports.normalizeMillisecondsFieldInString = normalizeMillisecondsFieldInString;
function normalizeMillisecondsField(msString) {
    // fix up milliseconds by padding zeros and/or truncating (5 --> 500, 50 --> 500, 54321 --> 543, etc.)
    return (msString = (msString + '00').substring(0, 3));
}
exports.normalizeMillisecondsField = normalizeMillisecondsField;
function getTimezoneSeparatorFromString(string) {
    if (string != null) {
        var matches = string.match(/-/);
        if (matches && matches.length === 1) {
            return '-';
        }
        matches = string.match(/\+/);
        if (matches && matches.length === 1) {
            return '+';
        }
    }
    return '';
}
exports.getTimezoneSeparatorFromString = getTimezoneSeparatorFromString;
function asyncMergeSort(arr, compareFn) {
    return __awaiter(this, void 0, void 0, function () {
        var midpoint, left, right;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (arr.length <= 1)
                        return [2 /*return*/, arr];
                    midpoint = Math.floor(arr.length / 2);
                    return [4 /*yield*/, asyncMergeSort(arr.slice(0, midpoint), compareFn)];
                case 1:
                    left = _a.sent();
                    return [4 /*yield*/, asyncMergeSort(arr.slice(midpoint), compareFn)];
                case 2:
                    right = _a.sent();
                    return [2 /*return*/, merge(left, right, compareFn)];
            }
        });
    });
}
exports.asyncMergeSort = asyncMergeSort;
function merge(left, right, compareFn) {
    return __awaiter(this, void 0, void 0, function () {
        var sorted, sortedElem, sortedElem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sorted = [];
                    _a.label = 1;
                case 1:
                    if (!(left.length > 0 && right.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, compareFn(left[0], right[0])];
                case 2:
                    if ((_a.sent()) < 0) {
                        sortedElem = left.shift();
                        if (sortedElem !== undefined) {
                            sorted.push(sortedElem);
                        }
                    }
                    else {
                        sortedElem = right.shift();
                        if (sortedElem !== undefined) {
                            sorted.push(sortedElem);
                        }
                    }
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, __spreadArray(__spreadArray(__spreadArray([], sorted, true), left, true), right, true)];
            }
        });
    });
}
function isPromise(res) {
    if (res == null)
        return false;
    return typeof res.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=util.js.map